import { gettext } from '@eventbrite/i18n';

export const PDF_WIDTH = 600;
export const PDF_HEIGHT = PDF_WIDTH * 2;

// This is the ratio between the line height and the font size.
export const TEXT_RATIO = 0.2;

// PDF circles diameter ratio
export const CIRCLE_DIAMETER_PDF_FACTOR = 0.7;

// Print options
export const PRINT_OPTION_TIER_COLOR = 'tierColor';
export const PRINT_OPTION_SEAT_LABELS = 'seatLabels';
export const PRINT_OPTION_HOLDS = 'holds';
export const PRINT_OPTION_AVAILABILITY = 'availability';
export const PRINT_OPTION_LEGEND = 'legend';

export const PRINT_OPTIONS = [
    {
        id: PRINT_OPTION_TIER_COLOR,
        label: gettext('Tier color'),
    },
    {
        id: PRINT_OPTION_SEAT_LABELS,
        label: gettext('Seat labels'),
    },
    {
        id: PRINT_OPTION_HOLDS,
        label: gettext('Holds'),
    },
    {
        id: PRINT_OPTION_AVAILABILITY,
        label: gettext('Availability'),
    },
];

export const TABLE_COLOR = '#c2e4f2';

export const CHAIR_RADIUS_PDF_FACTOR = 1;
export const CHAIR_RADIUS_SECTIONS_LABELS_PDF_FACTOR = 7;
export const CHAIR_RADIUS_SEATS_LABELS_PDF_FACTOR = 4;
